<!--
  PolyModal — vetted Poly-tier modal.

  Wraps `vue-final-modal`'s <VueFinalModal> with SUIT-namespaced
  classes (`.poly-Modal*`) styled by
  resources/assets/scss/nylon/components/_PolyModal.scss. Preserves
  the legacy modal chrome (white card, drop shadow, accented
  close-X). Renamespaceable to `.nylon-Modal` in a future redesign.

  Props:
    title (string)    — heading text, required.
    modalId (string)  — vue-final-modal modal id, required (consumers
                        already pass this so they can call vfm.close()
                        from elsewhere).

  Slots:
    default — modal body content.

  Emits:
    close  — fired when the close-X button is clicked.
    closed — fired once the modal has closed, however it was closed
             (vfm.close(), the close-X, the overlay, Escape).
-->
<template>
  <VueFinalModal class="poly-Modal" content-class="poly-Modal-content" overlay-transition="vfm-fade" content-transition="vfm-fade" :modal-id="modalId" @closed="$emit('closed')">
    <header class="poly-Modal-header">
      <h4 class="poly-Modal-title">{{ title }}</h4>
      <button type="button" class="poly-Modal-close" aria-label="Close" @click="$emit('close')"></button>
    </header>
    <main class="poly-Modal-body">
      <slot />
    </main>
  </VueFinalModal>
</template>

<script>
import { VueFinalModal } from "vue-final-modal";

export default {
  name: "PolyModal",

  components: { VueFinalModal },

  emits: ["close", "closed"],

  props: {
    title: {
      type: String,
      required: true,
    },
    modalId: {
      type: [String, Number, Symbol],
      required: true,
    },
  },
};
</script>
